module.exports = __webpack_public_path__ + "static/articles.bf14ed8b.png";